import { useEffect, useState } from 'react';

interface Props {
  images: string[];
  startIndex?: number;
  onClose: () => void;
}

export function Lightbox({ images, startIndex = 0, onClose }: Props) {
  const [idx, setIdx] = useState(startIndex);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') setIdx((i) => Math.min(images.length - 1, i + 1));
      if (e.key === 'ArrowLeft') setIdx((i) => Math.max(0, i - 1));
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [images.length, onClose]);

  if (images.length === 0) return null;
  const src = images[idx];

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 bg-black/95 text-white flex flex-col"
    >
      <div className="flex justify-between items-center px-4 py-3">
        <span className="text-sm">
          {idx + 1} / {images.length}
        </span>
        <button
          type="button"
          onClick={onClose}
          aria-label="close"
          className="w-9 h-9 rounded-full bg-white/15 inline-flex items-center justify-center"
        >
          ×
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        {src ? <img src={src} alt="" className="max-h-full max-w-full object-contain" /> : null}
      </div>
      <div className="flex justify-between p-4 gap-2">
        <button
          type="button"
          onClick={() => setIdx((i) => Math.max(0, i - 1))}
          disabled={idx === 0}
          className="flex-1 py-2 rounded-xl bg-white/15 disabled:opacity-40"
        >
          ‹
        </button>
        <button
          type="button"
          onClick={() => setIdx((i) => Math.min(images.length - 1, i + 1))}
          disabled={idx === images.length - 1}
          className="flex-1 py-2 rounded-xl bg-white/15 disabled:opacity-40"
        >
          ›
        </button>
      </div>
    </div>
  );
}
